// src/components/help/FAQSection.js
import React from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "How do I join a league?",
      answer:
        "To join a league, you need to receive an invitation or request to join an existing league from the League page.",
    },
    {
      question: "How are points calculated?",
      answer:
        "Points are calculated based on fighter performance metrics. Check the Events page for more details.",
    },
    {
      question: "How do I create an event?",
      answer:
        "To create an event, go to the Events page and click on the 'Create Event' button.",
    },
    {
      question: "What is DayShift Sports MMA?",
      answer:
        "DayShift Sports MMA is a platform where you can create and join leagues, participate in events, and compete in fantasy MMA.",
    },
  ];

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-dark-grey mb-4">FAQ</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4">
          <h3 className="text-lg font-semibold text-deep-red">
            {faq.question}
          </h3>
          <p className="text-dark-grey">{faq.answer}</p>
        </div>
      ))}
    </div>
  );
};

export default FAQSection;
